import Image from 'next/image';

import cardIconLearn from '@/assets/card_icon_learn.png';
import cardIconTournament from '@/assets/card_icon_tournament.png';
import preview1 from '@/assets/personality_preview_1.jpg';
import preview2 from '@/assets/personality_preview_2.jpg';
import preview3 from '@/assets/personality_preview_3.jpg';
import preview4 from '@/assets/personality_preview_4.jpg';

const PREVIEWS = [preview1, preview2, preview3, preview4];

export const ALL_FEATURES = [
  {
    href: '/tournaments',
    title: '🏆 Compete in Tournaments',
    description:
      'Test your investing skills against other players in real-time stock picking competitions.',
    iconSrc: cardIconTournament,
    cta: 'Enter tournament',
  },
  {
    href: '/learn',
    title: '📚 Learn Your Way',
    description:
      'Get AI-generated courses on any stock or industry, personalized to your skill level.',
    iconSrc: cardIconLearn,
    cta: 'Start lesson',
  },
  {
    href: '/your-type',
    title: '🧠 Discover Your Investor Type',
    description:
      'Take a quick quiz to find your investing personality and get portfolio recommendations.',
    iconNode: (
      <div className="flex justify-center" style={{ perspective: '1000px' }}>
        <div
          className="relative h-[120px] w-[68px] animate-carousel-spin md:h-[160px] md:w-[90px] xl:h-[200px] xl:w-[112px]"
          style={{ transformStyle: 'preserve-3d' }}
        >
          {PREVIEWS.map((src, i) => (
            <div
              key={i}
              className="absolute inset-0 animate-carousel-card-fade overflow-hidden rounded-lg border border-white/10 shadow-xl"
              style={{
                transform: `rotateY(${i * 90}deg) translateZ(clamp(80px, 10vw, 120px))`,
                animationDelay: `${i * -3}s`,
              }}
            >
              <Image
                src={src}
                alt={`Quiz result preview ${i + 1}`}
                fill
                className="object-cover"
                sizes="(max-width: 768px) 68px, (max-width: 1280px) 90px, 112px"
              />
            </div>
          ))}
        </div>
      </div>
    ),
    cta: 'Start test',
  },
];
